export default {"src":"/login-app/[GIT_HASH]/_next/static/media/settings_backup_restore.916872fb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};